import { createBrowserRouter, Navigate } from 'react-router'
import { RouterProvider } from 'react-router/dom'

import { AppLayout, loader as appLayoutLoader } from './components/AppLayout'
import { BillingPage } from './pages/BillingPage'
import { DocumentsPage } from './pages/DocumentsPage'
import { EmployeesPage } from './pages/EmployeesPage'
import { HomePage } from './pages/HomePage'
import { PayrollDeductionsPage } from './pages/PayrollDeductionsPage'
import { ProfilePage } from './pages/ProfilePage'
import { ResourcesPage } from './pages/ResourcesPage'
import { AllowanceSettingsPage } from './pages/settings/AllowanceSettingsPage'
import { BankingSettingsPage } from './pages/settings/BankingSettingsPage'
import { CompanySettingsPage } from './pages/settings/CompanySettingsPage'
import { PayrollSettingsPage } from './pages/settings/PayrollSettingsPage'
import { SettingsPage } from './pages/SettingsPage'

const router = createBrowserRouter([
  {
    path: 'employers/dashboard',
    element: <AppLayout />,
    loader: appLayoutLoader,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: 'employees',
        element: <EmployeesPage />,
      },
      {
        path: 'deductions',
        element: <PayrollDeductionsPage />,
      },
      {
        path: 'documents',
        element: <DocumentsPage />,
      },
      {
        path: 'resources',
        element: <ResourcesPage />,
      },
      {
        path: 'billing',
        element: <BillingPage />,
      },
      {
        path: 'settings',
        element: <SettingsPage />,
        children: [
          {
            path: '',
            element: <Navigate to='company' replace />,
          },
          {
            path: 'company',
            element: <CompanySettingsPage />,
          },
          {
            path: 'allowances',
            element: <AllowanceSettingsPage />,
          },
          {
            path: 'banking',
            element: <BankingSettingsPage />,
          },
          {
            path: 'payroll',
            element: <PayrollSettingsPage />,
          },
        ],
      },
      {
        path: 'profile',
        element: <ProfilePage />,
      }
    ],
  },
])

export function EmployerDashboardApp () {
  return <RouterProvider router={router} />
}
